import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "vendorSection", "individualSection"];

  toggle() {
    const selected = this.selectTarget.value;

    // Handle vendor sections
    this.vendorSectionTargets.forEach((el) => {
      const shouldShow = selected === el.dataset.typeValue || 
                        (selected === "device_vendor" && el.dataset.typeValue === "device_vendor");
      el.classList.toggle("hidden", !shouldShow);
    });

    // Handle individual sections  
    this.individualSectionTargets.forEach((el) => {
      const shouldShow = selected === el.dataset.typeValue || 
                        (selected === "general_public" && el.dataset.typeValue === "general_public");
      el.classList.toggle("hidden", !shouldShow);
    });
  }

  // Listen for user type selection changes from the user type component
  connect() {
    // Listen for changes from user type selection component
    document.addEventListener('change', (event) => {
      if (event.target.name === 'user[user_type]' && event.target.type === 'radio') {
        this.selectTarget.value = event.target.value;
        this.toggle();
      }
    });
  }
}
